export enum AUDIT_PERMISSIONS {
  VIEW = 'AUDIT_VIEW',
  WRITE = 'AUDIT_WRITE',
}

export enum AUDIT_ITEM_PERMISSIONS {
  VIEW = 'AUDIT_ITEM_VIEW',
  WRITE = 'AUDIT_ITEM_WRITE',
}

export enum AUDIT_SECTION_PERMISSIONS {
  VIEW = 'AUDIT_SECTION_VIEW',
  WRITE = 'AUDIT_SECTION_WRITE',
}
